declare const apiUrl: string;
declare const isea3Url: string;
declare const environment: string;
declare const release: string;
declare const buildTime: number;

interface Config {
  apiUrl: string;
  isea3Url: string;
  environment: string;
  release: string;
  buildTime: number;
}

let config: Config | null = null;

export const getConfig: () => Config = () => {
  if (config === null) {
    config = {
      apiUrl: apiUrl,
      isea3Url: isea3Url,
      environment: environment,
      release: release,
      buildTime: buildTime,
    };
  }

  return config;
};
